<p>uploader works!</p>






<!-- <div class="container">
    <form [formGroup]="form" (ngSubmit)="submitUser()">
       
        <div class="progress form-group" *ngIf="progress > 0">
            <div class="progress-bar progress-bar-striped bg-success" role="progressbar" [style.width.%]="progress">
            </div>
        </div>
        <div class="form-group">
            <input type="file" (change)="uploadFile($event)">
        </div>
        <div class="form-group input-group-lg">
            <input class="form-control" placeholder="Name" formControlName="name">
        </div>
        <div class="form-group">
            <button class="btn btn-danger btn-block btn-lg">Create</button>
        </div>
    </form>
</div> -->

<div class="row" style="margin-bottom:15px;">
  <div class="col-md-3">
    <input type="file" #file placeholder="Choose file" (change)="uploadFile(file.files)" style="display:none;">
    <button type="button" class="btn btn-success" (click)="file.click()">Upload File</button>
  </div>
  <div class="col-md-4">
    <div class="progress form-group" *ngIf="progress > 0">
      <div class="progress-bar progress-bar-striped bg-success" role="progressbar" [style.width.%]="progress" style="color:
            rgb(39, 237, 39)">
            <span class="upload" style="color: rgb(245, 241, 241);position:relative;">
              {{progress}}%
            </span>
      </div>
      
    </div>

    <span class="upload" *ngIf="message">
      {{message}}
    </span>
  </div>
</div>